import { MsalProvider } from '@azure/msal-react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import 'style/style.scss'
import './i18n'
import { Provider } from 'urql'
import client from 'urqlClient'
import { msalInstance } from 'auth'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <Provider value={client}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </Provider>
        </MsalProvider>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
